module.exports = require("gc-stats");